import React, {useMemo} from 'react'
import {useIntl} from 'react-intl'
import {filterMessages} from 'components/Filters/filterMessages'
import {useFiltersForm} from 'hooks/useFiltersForm'
import useShowOverlay from 'hooks/useShowOverlay/useShowOverlay'
import {OverlayType} from 'modules/overlay/types'
import {searchParamToFacet} from 'modules/search/constants'

import {Icon} from '@vio/atlas/Icon'
import {Pill} from '@vio/atlas/Pill'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {ReviewScoreBottomSheet} from './ReviewScoreBottomSheet'

const filterKeys = [searchParamToFacet.reviewScore.param]

interface Props {
  isActive?: boolean
  isQuickFilter?: boolean
  quickFilterValue?: string
}

export const ReviewScorePill: React.FC<Props> = ({
  isActive = false,
  isQuickFilter = false,
  quickFilterValue = '8'
}) => {
  const showOverlay = useShowOverlay()

  const {formatMessage} = useIntl()
  const {getAppliedFilters, submitFilters} = useFiltersForm(filterKeys)

  const appliedReviewScoreFilter = getAppliedFilters().reviewScore

  const label = useMemo(() => {
    if (!appliedReviewScoreFilter && !isQuickFilter) {
      return formatMessage(filterMessages.reviewScore)
    }

    return (
      <FormattedMessageWrapper
        id="guestRatingsWithValue"
        defaultMessage="{value}+ rating"
        values={{
          value: Number(
            isQuickFilter ? quickFilterValue : appliedReviewScoreFilter
          ).toFixed(1)
        }}
      />
    )
  }, [appliedReviewScoreFilter, formatMessage, isQuickFilter, quickFilterValue])

  const handleOnPillClick = () => {
    if (!isQuickFilter) {
      showOverlay({
        type: OverlayType.ReviewScoreFilter
      })
    } else {
      submitFilters({
        reviewScore: quickFilterValue
      })
    }
  }

  if (isQuickFilter && isActive) {
    return null
  }

  return (
    <>
      <Pill
        dataId={isQuickFilter ? 'reviewScoreQuickFilter' : 'reviewScoreFilter'}
        onClick={handleOnPillClick}
        isSelected={isActive}
        showArrow={!isQuickFilter}
        iconStart={isQuickFilter && <Icon name="SpeechBubble" />}
      >
        {label}
      </Pill>
      <ReviewScoreBottomSheet />
    </>
  )
}
